var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('DragPanel',{attrs:{"title":"漫游","closePanel":_vm.closeDialog,"tooltipVisible":false}},[_c('Roaming',{ref:"roamAnimate",attrs:{"dataSetList":_vm.dataSetList}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }